// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PIdCardOutlinedSvg from "@fishx/icons-svg/es/asn/PIdCardOutlined";
import FishxIcon from '../components/FishxIcon';

var PIdCardOutlined = function PIdCardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PIdCardOutlinedSvg
  }));
};

PIdCardOutlined.displayName = 'PIdCardOutlined';
export default React.forwardRef(PIdCardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PIdCardOutlined.js
// module id = 3458
// module chunks = 0